// extracted by mini-css-extract-plugin
export default {"SpinnerDefault":"wbfjYPQOYIkn9A1Uokwf","SpinnerLarge":"NrzrZZihpVsbahEU5hTA","SpinnerSeasonal":"kcDhP9jP5aQCQVzuJQN_"};